import styled from 'styled-components';
import { SingleSelect } from '../../../Select/Single';
import { Input } from '../../../Input';

export const Container = styled.div`
  flex: 1;
  margin: 0 16px 24px 16px;
  display: flex;
  flex-direction: row;
`;

export const Spacer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
`;

export const StyledInput = styled(Input)`
  flex: 1;
`;

export const StyledSelect = styled(SingleSelect)`
  flex: 1;
  padding-left: 0.5rem;

  & input {
    text-overflow: initial;
  }
`;
